export function stripMarkup(raw: string): string {
  return raw.replace(/<mark[^>]*>(.*?)<\/mark>/g, '$1').replace(/\*\*(.*?)\*\*/g, '$1');
}
